import { useState } from "react";
import { searchCustomer } from "src/apis/customerApi";
import useUiuxStore from "src/store/useUiuxStore";
import { defaultWMS1141_R01Filter, useWMS1141_R01Store } from "src/containers/mes/WMS/WMS1141_R01/Store_WMS1141_R01";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";

interface Props {}

export const SearchSection_WMS1141_R01 = (props: Props) => {

	const {
		WMS1141_R01Filter, setWMS1141_R01Filter,
		selectedWMS1141_R01DetailList,
		WMS1141_R01DetailList,
		editWMS1141_R01,
		updateWMS1141_R01DetailList,
	} = useWMS1141_R01Store();

	const { setCodeSearchModalProps } = useUiuxStore();
	const { yesNoList } = useCommonCodeStore();

	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	const custInfoHandleFoucsId = 'infoCustInput_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find(value => value.customCd === searchText);
			}
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: WMS1141_R01Filter,
		setEditData: setWMS1141_R01Filter,
		defaultData: defaultWMS1141_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'WMS1141_R01_search'
	});

	return (
		<SearchSectionForm>
			<SearchDateRangeForm
				label="입고 조회 기간"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				dateRange={WMS1141_R01Filter.dateRange}
				setDateRange={(dateRange) => setWMS1141_R01Filter({ dateRange })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
				wrapperOption={{
					titleStyle: "h-[24px] flex items-center truncate shrink-0 w-[80px] min-w-[80px]",
				}}
			/>

			<SearchCodeModalForm
				label="거래처"
				value={WMS1141_R01Filter.customCd}
				valueLabel={WMS1141_R01Filter.customNm}
				handleFoucsId={custInfoHandleFoucsId}
				onChange={getFieldHandlers('customCd').onChange}
				onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
				onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
			/>

			<SearchDropDownForm
				label="Lot라벨자동출력"
				value={WMS1141_R01Filter.labelPrintAuto}
				onChangeItem={(item) => setWMS1141_R01Filter({ labelPrintAuto: item?.minorCd || 'N' })}
				optionList={yesNoList}
				initLabelLess={true}
				wrapperOption={{
					wrapperStyle: "w-[250px] min-w-[250px] mr-[10px]",
					titleStyle: "h-[24px] flex items-center truncate shrink-0 w-[100px] min-w-[100px]",
					selectStyle: "w-[120px] min-w-[120px] ",
				}}
			/>
		</SearchSectionForm>
	);
};

export default SearchSection_WMS1141_R01;